import { useState } from 'react';
import { Link } from 'react-router-dom';
import { content } from '../data/content';
import Logo from './Logo';
import { orderPath } from './ui/Ui';

const NAV = [
  { href: '#problem', label: content.navProblem },
  { href: '#features', label: content.navFeatures },
  { href: '#safety', label: content.navSafety },
  { href: '#testimonials', label: content.navReviews },
  { href: '#faq', label: content.navFaq },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      {/* الترتيب الطبيعي في الصفحة العربية: الشعار يمين والقائمة والزر يسار */}
      <div className="container mx-auto px-4 py-3 md:py-4 flex items-center justify-between gap-4 max-w-7xl">
        <a href="#home" className="shrink-0">
          <Logo className="text-3xl md:text-4xl" />
        </a>

        <div className="flex items-center gap-5 xl:gap-8">
          <nav className="hidden lg:flex gap-6 xl:gap-8 font-semibold text-sm xl:text-base">
            {NAV.map((item) => (
              <a key={item.href} href={item.href} className="text-z-navy hover:text-z-red transition">
                {item.label}
              </a>
            ))}
          </nav>

          {/* زر الطلب حاضر دائماً: نقرة واحدة من أي مكان في الصفحة */}
          <Link
            to={orderPath()}
            className="hidden sm:flex bg-z-red text-white px-6 py-2.5 font-bold text-sm hover:bg-z-red/90 rounded-full transition-all items-center gap-2 shadow-md shadow-z-red/30"
          >
            <i className="fa-solid fa-bag-shopping" /> {content.headerCta}
          </Link>

          <button
            className="lg:hidden p-2 text-z-navy"
            onClick={() => setMobileOpen((open) => !open)}
            aria-label="القائمة"
          >
            <i className={`fa-solid ${mobileOpen ? 'fa-xmark' : 'fa-bars'} text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="flex flex-col px-4 py-2 font-semibold">
            {NAV.map((item, i) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className={`py-3 text-z-navy ${i < NAV.length - 1 ? 'border-b border-gray-100' : ''}`}
              >
                {item.label}
              </a>
            ))}
            <Link
              to={orderPath()}
              onClick={() => setMobileOpen(false)}
              className="bg-z-red text-white py-3 font-bold rounded-full my-4 flex items-center justify-center gap-2 shadow-md shadow-z-red/30"
            >
              <i className="fa-solid fa-bag-shopping" /> {content.headerCta}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
